import styled from '@emotion/styled';

import { Formik, Form, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { DateTime } from 'luxon';

import { TextField, Grid, Button } from '@mui/material';

import Dialog from '../../../utils/utilities/Dialog';

import { BasicFlex } from '../../../utils/Common';

import Field from '../../../utils/FormikFields/Field';

import { useDialogForm } from '../../../contexts/DialogForm';

import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';

const BasicForm = styled(Form)`
  padding: 1rem 1.6rem;
`;

const AdjustmentForm = ({ push }) => {

  const { values: mainValues, setFieldValue } = useFormikContext();

  const { handleClose } = useDialogForm() || {};

  const addAdjustment = (values, { setSubmitting, resetForm }) => {
    let adjustments = mainValues?.adjustments || [];
    adjustments.push(values);
    setFieldValue("adjustments", adjustments);
    // props.setOpen(false);
    setSubmitting(false);
    resetForm();
    handleClose();
  }

  const cancel = (resetForm) => {
    resetForm();
    handleClose();
  }

  return (
    <Formik
        initialValues={{
          name: '',
          description: '',
          item_type: 'charge',
          quantity: 1,
          rate: '',
          rate_type: 'fixed',
          discount_level: 'bill',
          selected: true
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('Required'),
          description: Yup.string(),
          item_type: Yup.string().required('Required'),
          quantity: Yup.number().required('Required'),
          rate: Yup.number().required('Required'),
          rate_type: Yup.string().required('Required'),
          discount_level: Yup.string().required('Required')
        })}
        onSubmit={addAdjustment}
      >
        {({ isSubmitting, resetForm }) => (
          <BasicForm>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12}}>
                <Field
                  formFieldType="toggle"
                  name="item_type"
                  label="Item Type"
                  options={[
                    { value: 'charge', label: 'Charge' },
                    { value: 'discount', label: 'Discount' },
                  ]}
                  color="primary"
                  fullWidth
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Field
                  name="name"
                  label="Title"
                  fullWidth
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Field
                  name="rate"
                  label="Rate"
                  type="number"
                  fullWidth
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Field
                  name="rate_type"
                  label="Rate Type"
                  fullWidth
                  formFieldType="toggle"
                  options={[
                    { value: 'percentage', label: 'Percentage' },
                    { value: 'fixed', label: 'Fixed' },
                  ]}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Field
                  name="description"
                  label="Description"
                  fullWidth
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid size={{xs: 12}}>
                <BasicFlex justify="flex-end" gap="1.5rem">
                  <Button type="reset" disabled={isSubmitting} variant="outlined" onClick={() => cancel(resetForm)}>Cancel</Button>
                  <Button type="submit" disabled={isSubmitting} variant="contained" startIcon={<CalculateRoundedIcon />}>Add Adjustment</Button>
                </BasicFlex>
              </Grid>
            </Grid>
          </BasicForm>
        )}
      </Formik>
  )
}

// export default AdjustmentForm;


const CustomAdjustment = ({ push, ...props }) => {
 
  return (
    <Dialog
      title="Custom Item"
      key="custom-item"
      toggle={<Button sx={{marginTop: "1rem"}} startIcon={<CalculateRoundedIcon />} color="tertiary" variant="contained" size="small">Add Custom Charge</Button>}
      size="lg"
      useForm={true}
    >
      <AdjustmentForm push={push} />
    </Dialog>
  )
};

export default CustomAdjustment;